import type { SharedData } from "@src/context/ApplicationContext";

const FORM_SNAPSHOT_KEYS: Array<keyof SharedData> = [
  "coverCareForm",
  "policyholderForm",
  "yourInfoForm",
  "reviewDetailsForm",
];

export const buildSubmittedDataSnapshot = (data: Partial<SharedData>): Partial<SharedData> => {
  const snapshot = { ...data };

  for (const key of FORM_SNAPSHOT_KEYS) {
    delete snapshot[key];
  }

  return snapshot;
};
